import { apiAxios, authApiAxiosWithRefresh } from './customAxios';
import axios from 'axios';

interface SimilarParams {
    make: string;
    model: string;
    year: string;
    link: string
}

export const getSimilarLive = async (params: SimilarParams) => {
    const data = {
        make: params.make,
        model: params.model,
        year: params.year,
        link: params.link
    }
    
    try {
        const response = await (
            await authApiAxiosWithRefresh()
        ).post('/getSimilarLive', data, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data
    } catch (error) {
        console.error('Error posting data:', error);
    }
};
